import React from 'react';
import { debounce } from 'lodash';
import classnames from 'classnames';
import Icon from 'Shared/Icon';
import { isBrowser } from 'Shared/device-type';
import * as styles from './base.scss';
const LEFT = 'left';
const CENTER = 'center';
const RIGHT = 'right';
const TOP = 'top';
const BOTTOM = 'bottom';
const DEFAULT_TRANSLATEX = 0;
export default class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        this.el = null;
        this.state = {
            translateX: DEFAULT_TRANSLATEX,
            flip: false,
        };
        this.debouncedReadjust = debounce(() => this.readjust(), 200);
        this.keyboardListener = e => e.which === 27 && this.props.close();
    }
    componentDidMount() {
        this.adjust();
        window.addEventListener('resize', this.debouncedReadjust);
        window.addEventListener('keydown', this.keyboardListener);
    }
    componentWillUnmount() {
        this.debouncedReadjust.cancel();
        window.removeEventListener('resize', this.debouncedReadjust);
        window.removeEventListener('keydown', this.keyboardListener);
    }
    adjust() {
        if (!isBrowser() || !this.el) {
            return;
        }
        const elRect = this.el.getBoundingClientRect();
        const bodyRect = document.body.getBoundingClientRect();
        // Adjust horizontally if element is outside the window sides
        if (elRect.right > bodyRect.right) {
            this.setState({
                translateX: bodyRect.right - elRect.right,
            });
        }
        else if (elRect.left < bodyRect.left) {
            this.setState({
                translateX: -elRect.left + bodyRect.left,
            });
        }
        // Flip vertical alignment from `top` to `bottom` if element is above the window
        if (this.props.vertical === TOP && elRect.top < bodyRect.top) {
            this.setState({
                flip: true,
            });
        }
    }
    readjust() {
        if (this.state.translateX !== DEFAULT_TRANSLATEX) {
            this.setState({
                translateX: DEFAULT_TRANSLATEX,
            }, () => this.adjust());
        }
        else {
            this.adjust();
        }
    }
    transform() {
        const functions = [];
        if (this.props.horizontal === CENTER) {
            functions.push('translateX(-50%)');
        }
        if (this.state.translateX !== DEFAULT_TRANSLATEX) {
            functions.push(`translateX(${this.state.translateX}px)`);
        }
        return functions.join(' ');
    }
    render() {
        const horizontal = this.props.horizontal;
        const vertical = this.props.vertical;
        const verticalClassNames = this.state.flip
            ? {
                [styles.bottom]: true,
                [styles.vLeft]: vertical === LEFT,
            }
            : {
                [styles.top]: vertical === TOP,
                [styles.bottom]: vertical === BOTTOM,
                [styles.vLeft]: vertical === LEFT,
            };
        return (React.createElement("div", { className: classnames(styles.base, verticalClassNames), onClick: e => this.props.closeOnClick && this.props.close && this.props.close(e) },
            React.createElement("div", { className: classnames(styles.content, Object.assign({
                    [styles.left]: horizontal === LEFT,
                    [styles.center]: horizontal === CENTER,
                    [styles.right]: horizontal === RIGHT,
                }, verticalClassNames)), ref: el => (this.el = el) },
                this.props.children,
                this.props.close && this.props.closeButton && (React.createElement("button", { className: styles.close, onClick: e => this.props.close(e) },
                    React.createElement(Icon, { name: "close" }))))));
    }
}
Tooltip.defaultProps = {
    horizontal: CENTER,
    vertical: TOP,
};
